import { AES, enc } from 'crypto-js';

export class RecaptchaSkipTokenManager {

  private static SALT = 'ppm-cloud';
  private static STORE_KEY = 'recaptcha-skip-token';

  save(token: string): void {
    const date = new Date();
    const encrypted = this.encrypt(date, token);
    localStorage.setItem(RecaptchaSkipTokenManager.STORE_KEY, encrypted);
  }

  load(): string {
    const sToken = localStorage.getItem(RecaptchaSkipTokenManager.STORE_KEY);
    if (!sToken) return '';
    return this.decrypt(sToken);
  }

  clear(): void {
    localStorage.removeItem(RecaptchaSkipTokenManager.STORE_KEY);
  }

  private encrypt(date: Date, clearText: string) {
    const key = this.createKey(date);
    const ciphertext = AES.encrypt(clearText, key);
    return btoa(`${date.getTime()}:${ciphertext.toString()}`);
  }

  private decrypt(sToken: string) {
    try {
      const decoded = atob(sToken);
      const [dateStr, ciphertext] = decoded.split(':');
      const date = new Date(Number(dateStr));
      const key = this.createKey(date);
      return AES.decrypt(ciphertext, key).toString(enc.Utf8);
    } catch {
      return '';
    }
  }

  private createKey(date: Date) {
    return `${date.getTime()}:${RecaptchaSkipTokenManager.SALT}`;
  }
}
